import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GroupIcon from '@mui/icons-material/Group';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import clsx from 'clsx';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../../../routes';
import { DEFAULT_LIST_ID } from '../../../../../sic-lib/defaults';
import { useAppDispatch } from '../../../../../store/hooks';
import { setSidebar } from '../../../../../store/sidebarDrawer';
import NavLinkListItem from '../../../../Navigation/NavLinkListItem/NavLinkListItem';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        /* Important for height to be inforced because is a virtual list */
        height: '57px',
        overflow: 'hidden',
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    item: {
        listStyle: 'none',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
}));

interface Props {
    segmentId: number;
    name: string;
}

export default function SegmentItem({ segmentId, name }: Props) {
    const { classes } = useStyles();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkSelected =
            location.pathname.toLowerCase() === contactRoutes.setGroups(segmentId);

        setIsSelected(checkSelected);
    }, [location]);

    const handleSetShowList = () => {
        console.log('checkId: ', segmentId);
        dispatch(setSidebar({ groupsList: segmentId }));
    };

    return (
        <NavLinkListItem
            pathname={contactRoutes.setGroups(segmentId)}
            selected={isSelected}
            ContainerProps={{
                className: classes.root,
            }}
            ContainerComponent="div"
            className={clsx(
                segmentId !== DEFAULT_LIST_ID && classes.item,
                segmentId === DEFAULT_LIST_ID && classes.root,
            )}
        >
            <ListItemAvatar>
                <Avatar variant="rounded">
                    <GroupIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={name}
                primaryTypographyProps={{
                    className: classes.primaryText,
                    noWrap: true,
                }}
            />
            {segmentId !== DEFAULT_LIST_ID && (
                <ListItemSecondaryAction>
                    <IconButton araia-label="Expand list" onClick={handleSetShowList} size="large">
                        <ExpandMoreIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            )}
        </NavLinkListItem>
    );
}
